import { styled } from "../../theme";
export const FieldLabel = styled.label `
  font-size: 1.25em;
  line-height: 1.75em;

  ${({ disabled }) => disabled &&
    `
    opacity: 0.6;
    cursor: not-allowed;
    filter: saturate(25%);
  `}
`;
FieldLabel.defaultProps = {
    disabled: false,
};
